import { useState } from "react";
import "@/App.css";
import { ThemeProvider, useTheme } from "@/theme/ThemeContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { BootLoader } from "@/components/BootLoader";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Stats } from "@/components/Stats";
import { Services } from "@/components/Services";
import { Admin } from "@/components/Admin";
import { Industries } from "@/components/Industries";
import { GlobalPresence } from "@/components/GlobalPresence";
import { Experience } from "@/components/Experience";
import { Team } from "@/components/Team";
import { Testimonials } from "@/components/Testimonials";
import { FAQ } from "@/components/FAQ";
import { Partners } from "@/components/Partners";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { Chatbot } from "@/components/Chatbot";
import { TranslationOverlay } from "@/components/TranslationOverlay";

function AppInner() {
  const [booted, setBooted] = useState(false);
  const { theme } = useTheme();
  return (
    <div className={`App bg-[#030305] text-white min-h-screen selection:bg-[#00F0FF] selection:text-black ${theme === "light" ? "theme-light" : ""}`}>
      <BootLoader onDone={() => setBooted(true)} />
      <Nav />
      <main>
        <Hero />
        <Stats />
        <Services />
        <Admin />
        <Industries />
        <GlobalPresence />
        <Experience />
        <Team />
        <Testimonials />
        <FAQ />
        <Partners />
        <Contact />
      </main>
      <Footer />
      <Chatbot />
      <TranslationOverlay />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AppInner />
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
